import React from 'react';
import {
  Chart as ChartJS,
  Align,
  ChartData,
  Color,
  FontSpec,
  ScriptableAndScriptableOptions,
  ScriptableCartesianScaleContext,
  Title,
  LineElement,
  PointElement,
  Legend,
  Tooltip,
  LinearScale,
  CategoryScale,
  TickOptions,
} from 'chart.js';
import {_DeepPartialObject} from 'chart.js/dist/types/utils';
import {Line} from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);
interface CustomLineChartProps {
  data: ChartData<'line', number[] | undefined, string>;
  yAxisTitleOption?: _DeepPartialObject<{
    display: boolean;
    align: Align;
    text: string | string[];
    color: Color;
    font: ScriptableAndScriptableOptions<
      Partial<FontSpec>,
      ScriptableCartesianScaleContext
    >;
    padding: number;
  }>;
  yTick?: _DeepPartialObject<
    TickOptions & {
      sampleSize: number;
      align: Align | 'inner';
      autoSkip: boolean;
      autoSkipPadding: number;
      crossAlign: 'center' | 'near' | 'far';
      includeBounds: boolean;

      maxTicksLimit: number;
    }
  >;
}

const CustomLineChart = ({
  data,
  yAxisTitleOption,
  yTick,
}: CustomLineChartProps) => {
  return (
    <Line
      data={data}
      options={{
        responsive: true,
        interaction: {
          mode: 'index' as const,
          intersect: false,
        },

        scales: {
          x: {
            grid: {display: false},
          },
          y: {
            type: 'linear' as const,
            ticks: yTick,

            position: 'left' as const,
            display: true,
            title: yAxisTitleOption,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: false,
            text: 'Chart.js Line Chart',
          },
        },
      }}
    />
  );
};

export default CustomLineChart;
